module.exports = __webpack_public_path__ + "static/img/articlecargo.851e860.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/propaganda/articlecargo.jpg
// module id = cf0a
// module chunks = 1